import styled from 'styled-components';
import { IconFlag, spacer8, Type } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import { Resource } from '@hooks/useCurrentUserInfo/types';
import { useShowUnclearedVideoFlag } from '@hooks/useShowUnclearedVideos';
import { NavBarListItemAsLink } from '@components/shared/NavBarListItemAsLink';
import { _spotify_s4mpview_v1_WhoAmIResponse_NamedEntity__Output } from '@generated/grpc/spotify/s4mpview/v1';

interface UnclearedVideosTabProps {
  isActive: boolean;
  hrefParam: string;
  handleUnclearedVideosTabClickGAEvent: () => void;
  userLicensors: Resource[];
}

const StyledSpan = styled.span`
  padding-right: ${spacer8};
`;

const StyledType = styled(Type)`
  display: flex;
  align-items: center;
`;

export const UnclearedVideosNavbar = ({
  isActive,
  hrefParam,
  handleUnclearedVideosTabClickGAEvent,
  userLicensors,
}: UnclearedVideosTabProps) => {
  const t = useT();
  const licensorIds = userLicensors.map(licensor => licensor.id);
  const { doShow, isLoading } = useShowUnclearedVideoFlag(licensorIds);

  const UNCLEARED_VIDEOS_TEXT = t(
    'atlas.uncleared_videos',
    'Uncleared videos',
    'Title for Uncleared videos section',
  );

  return (
    <NavBarListItemAsLink
      active={isActive}
      href={hrefParam}
      onClick={() => handleUnclearedVideosTabClickGAEvent()}
      sentenceCase
    >
      <StyledType variant="celloCanon">
        <StyledSpan>
          {UNCLEARED_VIDEOS_TEXT}{' '}
          {!isLoading && doShow && (
            <IconFlag size="small" title={UNCLEARED_VIDEOS_TEXT} />
          )}
        </StyledSpan>
      </StyledType>
    </NavBarListItemAsLink>
  );
};
